import React from 'react';
import { Error } from './Error';

const WrongAuthMethodErrorComponent = () => {
  return <Error title={{ key: 'pages:errorBoundary.wrongAuthMethodError' }} />;
};

export default WrongAuthMethodErrorComponent;
